export const TIER_PRICE_DEPLOYER_ABI = [
  {
    inputs: [{ internalType: 'address', name: '_factory', type: 'address' }],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  { inputs: [], name: 'DeployTierPriceFail', type: 'error' },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'nonce',
        type: 'uint256',
      },
    ],
    name: 'IncreaseNonce',
    type: 'event',
  },
  {
    inputs: [{ internalType: 'address', name: '_expectAddress', type: 'address' }],
    name: 'deploy',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'nonce',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
];
